import {FileParameter, SuperBit_swaggerClient,ManufacturerModel,VehicleModelModel,SubModelWithDegem,VehicleSubModel} from './superbit-api-models'
import {IDNameDescriptionItem,IDNameDescriptionDictionary,AutocompleteData} from './Site';

import generalSettings from '../json/general-settings.json';

export class GeneralDataModel {
    client:any;
    testClient:any;
    serverTestClient:any;

    constructor() {
        //this.client = new SuperBit_swaggerClient("http://api.dev-alt1.superbit.co.il");
        const apiUrl = localStorage.getItem('apiUrl');
        this.client = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
        this.testClient = new SuperBit_swaggerClient("http://localhost:3001");

        this.serverTestClient = new SuperBit_swaggerClient(apiUrl ? apiUrl : generalSettings.apiUrl);
    }
    
    getVehicleManufaucters() {
        return this.client.vehicleInfoGetManufacturers();
    }

    async getVehicleInfoGetVehicleById(submodelIs:string){
        return await  this.client.vehicleInfoGetVehicleById(submodelIs);
    }

    async getVehicleInfoGetVehicleSubModelsById(submodelIs:string){
        return await  this.client.vehicleInfoGetVehicleSubModelsById(submodelIs);
    }

    async getVehicleInfoGetVehicleSubModelsByModelCode(modelCode:string):Promise<VehicleSubModel>{
        return await  this.client.vehicleInfoGetVehicleSubModelsByModelCode(modelCode);
    }


    

    getVehicleModels(manufacturerId: string | undefined) {
        
        return this.client.leadsVehicleModelsGet(undefined, manufacturerId);
    }

    getVehicleSubModels(modelId: string | undefined) {
        return this.client.leadsVehicleSubModelsGet(undefined, modelId);
    }

    getVehicleSubModelsByManufacturer(manufacturerId: string | undefined) {
        return this.client.leadsVehicleSubModelsGetByManufacturerId(undefined, manufacturerId);
    }


    async uploadFile(location: string, files: FileParameter[]) {
        return await this.client.sharedUploadFile(location, files)
    }

    async customerCardGetCreators() {
        return await this.client.customerCardGetCreators();
    }

    vehicleInfoCreateManufacturer(body: ManufacturerModel| undefined) {
        return this.client.vehicleInfoCreateManufacturer(body);
    }

    vehicleInfoCreateVehicleModel(body: VehicleModelModel | undefined) {
        
        return this.client.vehicleInfoCreateVehicleModel(body);
    }

    vehicleInfoCreateVehicleSubModel(body: SubModelWithDegem | undefined) {
        
        return this.client.vehicleInfoCreateVehicleSubModel(body);
    }

    speakComSendCall(number:string, id :string) {
        try {
            return this.client.speakComSendCall(number,id);
        } catch (error) {
            return null;
        }
    }

    getInsuranceCompanies() {
        return this.client.getAppDictionaryList("InsuranceCompany");
    }
    getPolicyTypes() {
        return this.client.getAppDictionaryList("PolicyTypes");
    }

    getAppDictionaryListExpanded() {
        return this.client.getAppDictionaryList("ExpandedInsuranceTypes");
    }

    getRiderStatuses() {
        return this.client.getAppDictionaryList("RiderStatusType");
    }

    getSueStatuses() {
        return this.client.getAppDictionaryList("SueStatus2");
    }

    getSueTypes() {
        return this.client.getAppDictionaryList("SueType");
    }

    getSueActivityStatuses() {
        return this.client.getAppDictionaryList("SueActivityStatus");
    }

    getApartmentSueTypes() {
        return this.client.getAppDictionaryList("ApartmentSueType");
    }
    
    getExpandedInsuranceTypes() {
        return this.client.getAppDictionaryList("ExpandedInsuranceTypes");
    }

    getLicenseTypes(){
        return this.client.getAppDictionaryList("UsePurposesType");
    }

async getSalesHandlers(){
        return await this.client.userGetUserByRoleId('d29cf1da-0f50-4525-9a80-95cd6b5e3470');
    }

    async getClaimHandlers(){
        return await this.client.userGetUserByRoleId('8f2451b6-6eb6-4818-ad67-a4f832d9f905');
    }

    async getBankList(){
        let banksDetails = localStorage.getItem('BanksDetails');
        if (banksDetails === null) {
            try {    
            let bankListData = await this.client.getBankList();
            localStorage.setItem('BanksDetails', JSON.stringify(bankListData));
            return bankListData;
            } catch (error) {
                console.error("Failed to fetch banks:", error);
                return [];
            }
        }
        return banksDetails ? JSON.parse(banksDetails) : [];
    }

}